(function () {
  "use strict";

  const SELECTOR_ID = "naxarly-slot-selector";
  const STYLE_ID = "naxarly-slot-selector-style";
  const STATUS_CHECKING = "checking";
  const STATUS_UNKNOWN = "unknown";
  const TAMIL_NADU_DISTRICTS = [
    "Ariyalur", "Chengalpattu", "Chennai", "Coimbatore", "Cuddalore", "Dharmapuri",
    "Dindigul", "Erode", "Kallakurichi", "Kancheepuram", "Kanniyakumari", "Karur",
    "Krishnagiri", "Madurai", "Mayiladuthurai", "Nagapattinam", "Namakkal", "Nilgiris",
    "Perambalur", "Pudukkottai", "Ramanathapuram", "Ranipet", "Salem", "Sivaganga",
    "Tenkasi", "Thanjavur", "Theni", "Thoothukudi", "Tiruchirappalli", "Tirunelveli",
    "Tirupathur", "Tiruppur", "Tiruvallur", "Tiruvannamalai", "Tiruvarur", "Vellore",
    "Viluppuram", "Virudhunagar"
  ];
  const DISTRICT_COORDINATES = {
    "Ariyalur":[11.1401,79.0786],"Chengalpattu":[12.6819,79.9888],
    "Chennai":[13.0827,80.2707],"Coimbatore":[11.0168,76.9558],
    "Cuddalore":[11.7447,79.7680],"Dharmapuri":[12.1211,78.1582],
    "Dindigul":[10.3624,77.9695],"Erode":[11.3410,77.7172],
    "Kallakurichi":[11.7384,78.9622],"Kancheepuram":[12.8342,79.7036],
    "Kanniyakumari":[8.0883,77.5385],"Karur":[10.9601,78.0766],
    "Krishnagiri":[12.5186,78.2137],"Madurai":[9.9252,78.1198],
    "Mayiladuthurai":[11.1018,79.6526],"Nagapattinam":[10.7656,79.8424],
    "Namakkal":[11.2194,78.1677],"Nilgiris":[11.4064,76.6932],
    "Perambalur":[11.2320,78.8807],"Pudukkottai":[10.3833,78.8001],
    "Ramanathapuram":[9.3639,78.8395],"Ranipet":[12.9249,79.3333],
    "Salem":[11.6643,78.1460],"Sivaganga":[9.8433,78.4809],
    "Tenkasi":[8.9590,77.3152],"Thanjavur":[10.7870,79.1378],
    "Theni":[10.0104,77.4768],"Thoothukudi":[8.7642,78.1348],
    "Tiruchirappalli":[10.7905,78.7047],"Tirunelveli":[8.7139,77.7567],
    "Tirupathur":[12.4960,78.5730],"Tiruppur":[11.1085,77.3411],
    "Tiruvallur":[13.1439,79.9089],"Tiruvannamalai":[12.2253,79.0747],
    "Tiruvarur":[10.7661,79.6344],"Vellore":[12.9165,79.1325],
    "Viluppuram":[11.9401,79.4861],"Virudhunagar":[9.5680,77.9624]
  };

  let isMounted = false;
  let latestAvailability = null;
  let latestAvailabilityData = null;
  let listeners = [];
  let elements = {};
  let lastTrigger = null;
  let automaticRecheckTimer = null;
  let countdownTimer = null;

  function clone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function getEventApi() {
    return window.Naxarly && window.Naxarly.Event ? window.Naxarly.Event : null;
  }

  function getAvailabilityApi() {
    return window.Naxarly && window.Naxarly.Availability ? window.Naxarly.Availability : null;
  }

  function getDefaultAvailabilityData() {
    return window.Naxarly && window.Naxarly.availabilityData ? window.Naxarly.availabilityData : {};
  }

  function normalizeSlot(slot) {
    const source = slot || {};

    return {
      date: typeof source.date === "string" ? source.date : "",
      time: typeof source.time === "string" ? source.time : "",
      location: typeof source.location === "string" ? source.location : ""
    };
  }

  function getSavedSlot() {
    const eventApi = getEventApi();

    if (!eventApi) {
      return normalizeSlot();
    }

    const availability = eventApi.getAvailability();

    return normalizeSlot({
      date: availability.date,
      time: availability.time,
      location: availability.location || availability.city
    });
  }

  function setEventAvailability(slot, status) {
    const eventApi = getEventApi();

    if (!eventApi) {
      return;
    }

    const coordinates = DISTRICT_COORDINATES[slot.location];
    const selectedPackage = window.Naxarly && window.Naxarly.ServicePage &&
      typeof window.Naxarly.ServicePage.getSelection === "function"
      ? window.Naxarly.ServicePage.getSelection()
      : null;
    eventApi.setAvailability({
      date: slot.date,
      time: slot.time,
      city: slot.location,
      label: slot.location + ", Tamil Nadu",
      latitude: coordinates ? coordinates[0] : null,
      longitude: coordinates ? coordinates[1] : null,
      packageStableKey: selectedPackage && selectedPackage.stableKey ? selectedPackage.stableKey : "",
      status: status || STATUS_UNKNOWN
    });
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }

    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = [
      ".naxarly-slot-selector-lock { overflow: hidden; }",
      ".naxarly-slot-selector { --nss-primary:var(--naxarly-primary,#5f2498); --nss-primary-dark:var(--naxarly-primary-hover,#4c1c7d); --nss-soft:var(--naxarly-primary-light,#f7f1fe); --nss-border:var(--naxarly-border,#e8e5f0); --nss-divider:var(--naxarly-divider,#ece8f5); --nss-text:var(--naxarly-text-primary,#1c1b2d); --nss-muted:var(--naxarly-text-secondary,#6f7285); position:fixed; inset:0; z-index:2147483000; display:none; font-family:inherit; }",
      ".naxarly-slot-selector * { box-sizing:border-box; }",
      ".naxarly-slot-selector.is-open { display:block; }",
      ".naxarly-slot-selector__overlay { position:absolute; inset:0; border:0; background:rgba(24,16,34,.46); backdrop-filter:blur(3px); }",
      ".naxarly-slot-selector__sheet { position:absolute; top:var(--naxarly-slot-top,92px); left:50%; width:min(calc(100vw - 32px),620px); max-height:calc(100dvh - var(--naxarly-slot-top,92px) - 18px); overflow:auto; overscroll-behavior:contain; border:1px solid var(--nss-border); border-radius:20px; background:#fff; color:var(--nss-text); box-shadow:0 24px 70px rgba(47,25,70,.24); transform:translate(-50%,-10px); opacity:0; transition:transform 180ms ease,opacity 180ms ease; }",
      ".naxarly-slot-selector__sheet::before { content:''; position:absolute; top:-7px; right:18%; width:14px; height:14px; border-top:1px solid var(--nss-border); border-left:1px solid var(--nss-border); background:#fff; transform:rotate(45deg); }",
      ".naxarly-slot-selector.is-open .naxarly-slot-selector__sheet { transform:translate(-50%,0); opacity:1; }",
      ".naxarly-slot-selector__inner { width:100%; margin:0 auto; padding:24px; }",
      ".naxarly-slot-selector__header { display:flex; align-items:flex-start; justify-content:space-between; gap:18px; margin-bottom:22px; padding-bottom:18px; border-bottom:1px solid var(--nss-divider); }",
      ".naxarly-slot-selector__heading { display:grid; grid-template-columns:42px minmax(0,1fr); gap:12px; align-items:center; }",
      ".naxarly-slot-selector__heading-icon { display:grid; width:42px; height:42px; place-items:center; border-radius:11px; background:var(--nss-soft); color:var(--nss-primary); }",
      ".naxarly-slot-selector__heading-icon svg,.naxarly-slot-selector__control-icon svg { width:20px; height:20px; fill:none; stroke:currentColor; stroke-width:1.8; stroke-linecap:round; stroke-linejoin:round; }",
      ".naxarly-slot-selector__title { margin:0; color:var(--nss-text); font-size:22px; line-height:1.25; font-weight:700; letter-spacing:-.015em; }",
      ".naxarly-slot-selector__subtitle { margin:3px 0 0; color:var(--nss-muted); font-size:13px; line-height:1.4; }",
      ".naxarly-slot-selector__close { display:grid; flex:0 0 auto; width:38px; height:38px; place-items:center; padding:0; border:1px solid var(--nss-divider); border-radius:50%; background:#fff; color:var(--nss-text); font-size:22px; line-height:1; cursor:pointer; }",
      ".naxarly-slot-selector__close:hover { border-color:#cdbdec; background:var(--nss-soft); color:var(--nss-primary); }",
      ".naxarly-slot-selector__form { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:16px; }",
      ".naxarly-slot-selector__field { position:relative; display:grid; min-width:0; gap:7px; }",
      ".naxarly-slot-selector__field--location { grid-column:1/-1; }",
      ".naxarly-slot-selector__field label { color:var(--nss-text); font-size:12px; font-weight:650; line-height:1.35; }",
      ".naxarly-slot-selector__control { position:relative; min-width:0; }",
      ".naxarly-slot-selector__control-icon { position:absolute; z-index:1; top:50%; left:14px; display:grid; width:20px; height:20px; place-items:center; color:var(--nss-primary); transform:translateY(-50%); pointer-events:none; }",
      ".naxarly-slot-selector__field input,.naxarly-slot-selector__field select { width:100%; min-height:52px; padding:10px 42px 10px 44px; border:1px solid #dcd6e4; border-radius:12px; outline:none; background:#fff; color:var(--nss-text); font:inherit; font-size:14px; line-height:1.3; transition:border-color 150ms ease,box-shadow 150ms ease,background 150ms ease; }",
      ".naxarly-slot-selector__field select { appearance:none; background-image:linear-gradient(45deg,transparent 50%,#777184 50%),linear-gradient(135deg,#777184 50%,transparent 50%); background-position:calc(100% - 19px) 22px,calc(100% - 14px) 22px; background-size:5px 5px,5px 5px; background-repeat:no-repeat; cursor:pointer; }",
      ".naxarly-slot-selector__field input:hover,.naxarly-slot-selector__field select:hover { border-color:#bca8d0; }",
      ".naxarly-slot-selector__field input:focus,.naxarly-slot-selector__field select:focus { border-color:var(--nss-primary); box-shadow:0 0 0 3px rgba(95,36,152,.11); }",
      ".naxarly-slot-selector__field input::placeholder { color:#9a94a4; }",
      ".naxarly-slot-selector__hint { margin:0; color:var(--nss-muted); font-size:11.5px; line-height:1.4; }",
      ".naxarly-slot-selector__location-list { position:absolute; z-index:5; top:calc(100% - 21px); right:0; left:0; max-height:224px; overflow-x:hidden; overflow-y:auto; overscroll-behavior:contain; touch-action:pan-y; -webkit-overflow-scrolling:touch; margin:0; padding:6px; border:1px solid var(--nss-border); border-radius:12px; background:#fff; box-shadow:0 16px 36px rgba(47,25,70,.16); list-style:none; }",
      ".naxarly-slot-selector__location-list[hidden] { display:none; }",
      ".naxarly-slot-selector__location-option { display:flex; width:100%; min-height:40px; align-items:center; gap:9px; padding:8px 10px; border:0; border-radius:8px; background:#fff; color:var(--nss-text); font:inherit; font-size:13px; text-align:left; cursor:pointer; }",
      ".naxarly-slot-selector__location-option::before { content:''; width:7px; height:7px; border:2px solid var(--nss-primary); border-radius:50%; }",
      ".naxarly-slot-selector__location-option:hover,.naxarly-slot-selector__location-option[aria-selected='true'] { background:var(--nss-soft); color:var(--nss-primary); }",
      ".naxarly-slot-selector__error { grid-column:1/-1; min-height:0; color:#a22121; font-size:13px; line-height:1.45; }",
      ".naxarly-slot-selector__error:empty { display:none; }",
      ".naxarly-slot-selector__temporary { display:grid; gap:6px; padding:13px; border:1px solid var(--nss-border); border-radius:11px; background:var(--nss-soft); color:#3f20b2; }",
      ".naxarly-slot-selector__temporary strong { color:var(--nss-text); }",
      ".naxarly-slot-selector__recheck { width:max-content; min-height:34px; padding:6px 11px; border:1px solid var(--nss-primary); border-radius:8px; background:#fff; color:var(--nss-primary); font:inherit; font-size:12px; font-weight:700; cursor:pointer; }",
      ".naxarly-slot-selector__alternatives { display:flex; flex-wrap:wrap; gap:7px; margin-top:5px; }",
      ".naxarly-slot-selector__alternative { min-height:34px; padding:6px 10px; border:1px solid var(--nss-border); border-radius:8px; background:#fff; color:#3f20b2; font:inherit; font-size:12px; cursor:pointer; }",
      ".naxarly-slot-selector__actions { grid-column:1/-1; display:flex; margin-top:2px; padding-top:2px; }",
      ".naxarly-slot-selector__button { min-height:50px; padding:0 18px; border:1px solid var(--nss-primary); border-radius:11px; font:inherit; font-size:14px; font-weight:700; cursor:pointer; transition:background 150ms ease,transform 150ms ease,box-shadow 150ms ease; }",
      ".naxarly-slot-selector__button--primary { width:100%; background:var(--nss-primary); color:#fff; box-shadow:0 8px 18px rgba(95,36,152,.18); }",
      ".naxarly-slot-selector__button--primary:hover { background:var(--nss-primary-dark); box-shadow:0 10px 22px rgba(95,36,152,.23); }",
      ".naxarly-slot-selector__button--primary:active { transform:scale(.99); }",
      ".naxarly-slot-selector__button[disabled] { opacity:.62; cursor:wait; }",
      ".naxarly-slot-selector button:focus-visible,.naxarly-slot-selector input:focus-visible,.naxarly-slot-selector select:focus-visible { outline:2px solid var(--nss-primary); outline-offset:2px; }",
      "@media (max-width:749px) { .naxarly-slot-selector__sheet { top:auto; bottom:0; width:100%; max-height:min(88dvh,720px); border-width:1px 0 0; border-radius:22px 22px 0 0; transform:translate(-50%,24px); } .naxarly-slot-selector__sheet::before { display:none; } .naxarly-slot-selector.is-open .naxarly-slot-selector__sheet { transform:translate(-50%,0); } .naxarly-slot-selector__sheet::after { content:''; position:absolute; top:8px; left:50%; width:38px; height:4px; border-radius:999px; background:#d9d3df; transform:translateX(-50%); } .naxarly-slot-selector__inner { padding:26px 18px calc(18px + env(safe-area-inset-bottom)); } .naxarly-slot-selector__header { margin-bottom:18px; padding-bottom:16px; } .naxarly-slot-selector__title { font-size:20px; } .naxarly-slot-selector__form { grid-template-columns:1fr; gap:14px; } .naxarly-slot-selector__field--location,.naxarly-slot-selector__error,.naxarly-slot-selector__actions { grid-column:1; } }",
      "@media (max-width:370px) { .naxarly-slot-selector__inner { padding-right:14px; padding-left:14px; } .naxarly-slot-selector__heading { grid-template-columns:38px minmax(0,1fr); gap:10px; } .naxarly-slot-selector__heading-icon { width:38px; height:38px; } .naxarly-slot-selector__subtitle { font-size:12px; } }",
      "@media (prefers-reduced-motion:reduce) { .naxarly-slot-selector__sheet,.naxarly-slot-selector__button { transition:none; } }"
    ].join("");

    document.head.appendChild(style);
  }

  function createIcon(name, className) {
    const icon = document.createElement("span");
    const paths = {
      location: '<path d="M12 21s6-5.33 6-11a6 6 0 1 0-12 0c0 5.67 6 11 6 11Z"/><circle cx="12" cy="10" r="2.2"/>',
      calendar: '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 10h18"/>',
      clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.5 2"/>'
    };

    icon.className = className || "naxarly-slot-selector__control-icon";
    icon.setAttribute("aria-hidden", "true");
    icon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + paths[name] + "</svg>";
    return icon;
  }

  function wrapControl(control, iconName) {
    const wrapper = document.createElement("div");
    wrapper.className = "naxarly-slot-selector__control";
    wrapper.appendChild(createIcon(iconName));
    wrapper.appendChild(control);
    return wrapper;
  }

  function createField(id, labelText, type, autocomplete, iconName) {
    const field = document.createElement("div");
    const label = document.createElement("label");
    const input = document.createElement("input");

    field.className = "naxarly-slot-selector__field";
    label.setAttribute("for", id);
    label.textContent = labelText;
    input.id = id;
    input.name = id;
    input.type = type;
    input.autocomplete = autocomplete;

    field.appendChild(label);
    field.appendChild(wrapControl(input, iconName));

    return {
      field: field,
      input: input
    };
  }

  function createLocationField() {
    const result = createField("naxarly-slot-location", "Event location", "search", "address-level2", "location");
    const list = document.createElement("ul");
    const hint = document.createElement("p");

    list.id = "naxarly-tamil-nadu-districts";
    list.className = "naxarly-slot-selector__location-list";
    list.setAttribute("role", "listbox");
    list.hidden = true;
    result.field.classList.add("naxarly-slot-selector__field--location");
    result.input.placeholder = "Search by district";
    result.input.setAttribute("role", "combobox");
    result.input.setAttribute("aria-autocomplete", "list");
    result.input.setAttribute("aria-controls", list.id);
    result.input.setAttribute("aria-expanded", "false");
    hint.className = "naxarly-slot-selector__hint";
    hint.textContent = "All Tamil Nadu districts are supported";
    result.field.appendChild(list);
    result.field.appendChild(hint);
    result.list = list;
    return result;
  }

  function createTimeField() {
    const field = document.createElement("div");
    const label = document.createElement("label");
    const select = document.createElement("select");

    field.className = "naxarly-slot-selector__field";
    label.setAttribute("for", "naxarly-slot-time");
    label.textContent = "Event start time";
    select.id = "naxarly-slot-time";
    select.name = "naxarly-slot-time";
    for (let minutes = 0; minutes < 24 * 60; minutes += 30) {
      const hour = Math.floor(minutes / 60);
      const minute = minutes % 60;
      const option = document.createElement("option");
      const hour12 = hour % 12 || 12;
      const suffix = hour < 12 ? "AM" : "PM";
      option.value = String(hour).padStart(2, "0") + ":" + String(minute).padStart(2, "0");
      option.textContent = hour12 + ":" + String(minute).padStart(2, "0") + " " + suffix;
      select.appendChild(option);
    }
    field.appendChild(label);
    field.appendChild(wrapControl(select, "clock"));
    return { field: field, input: select };
  }

  function closeLocationList() {
    if (!elements.locationList) return;
    elements.locationList.hidden = true;
    elements.locationInput.setAttribute("aria-expanded", "false");
    elements.locationInput.removeAttribute("aria-activedescendant");
  }

  function selectLocation(district) {
    elements.locationInput.value = district;
    closeLocationList();
    elements.locationInput.focus();
  }

  function drawLocationOptions(query) {
    const value = String(query || "").trim().toLocaleLowerCase("en-IN");
    const matches = TAMIL_NADU_DISTRICTS.filter(function (district) {
      return !value || district.toLocaleLowerCase("en-IN").includes(value);
    });

    elements.locationList.replaceChildren();
    matches.forEach(function (district, index) {
      const item = document.createElement("li");
      const option = document.createElement("button");
      option.type = "button";
      option.id = "naxarly-slot-location-option-" + index;
      option.className = "naxarly-slot-selector__location-option";
      option.setAttribute("role", "option");
      option.textContent = district;
      option.addEventListener("click", function () {
        selectLocation(district);
      });
      item.appendChild(option);
      elements.locationList.appendChild(item);
    });
    elements.locationList.hidden = !matches.length;
    elements.locationInput.setAttribute("aria-expanded", matches.length ? "true" : "false");
  }

  function handleLocationKeydown(event) {
    const options = Array.from(elements.locationList.querySelectorAll('[role="option"]'));
    if (!options.length && (event.key === "ArrowDown" || event.key === "ArrowUp")) {
      drawLocationOptions(elements.locationInput.value);
      return;
    }
    const activeId = elements.locationInput.getAttribute("aria-activedescendant");
    let activeIndex = options.findIndex(function (option) { return option.id === activeId; });
    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault();
      activeIndex = event.key === "ArrowDown"
        ? Math.min(activeIndex + 1, options.length - 1)
        : Math.max(activeIndex < 0 ? options.length - 1 : activeIndex - 1, 0);
      options.forEach(function (option, index) {
        option.setAttribute("aria-selected", index === activeIndex ? "true" : "false");
      });
      elements.locationInput.setAttribute("aria-activedescendant", options[activeIndex].id);
      options[activeIndex].scrollIntoView({ block: "nearest" });
    } else if (event.key === "Enter" && activeIndex >= 0) {
      event.preventDefault();
      selectLocation(options[activeIndex].textContent);
    } else if (event.key === "Escape") {
      if (!elements.locationList.hidden) {
        event.stopPropagation();
      }
      closeLocationList();
    }
  }

  function mount() {
    if (isMounted) {
      return;
    }

    injectStyles();

    const root = document.createElement("div");
    const overlay = document.createElement("button");
    const sheet = document.createElement("div");
    const inner = document.createElement("div");
    const header = document.createElement("div");
    const heading = document.createElement("div");
    const headingCopy = document.createElement("div");
    const title = document.createElement("h2");
    const subtitle = document.createElement("p");
    const closeButton = document.createElement("button");
    const form = document.createElement("form");
    const locationField = createLocationField();
    const dateField = createField("naxarly-slot-date", "Event date", "date", "off", "calendar");
    dateField.input.min = new Date().toLocaleDateString("en-CA", {
      timeZone: "Asia/Kolkata"
    });
    const timeField = createTimeField();
    const error = document.createElement("div");
    const actions = document.createElement("div");
    const submitButton = document.createElement("button");

    root.id = SELECTOR_ID;
    root.className = "naxarly-slot-selector";
    root.setAttribute("aria-hidden", "true");

    overlay.className = "naxarly-slot-selector__overlay";
    overlay.type = "button";
    overlay.setAttribute("aria-label", "Close event slot selector");

    sheet.className = "naxarly-slot-selector__sheet";
    sheet.setAttribute("role", "dialog");
    sheet.setAttribute("aria-modal", "true");
    sheet.setAttribute("aria-labelledby", "naxarly-slot-selector-title");

    inner.className = "naxarly-slot-selector__inner";
    header.className = "naxarly-slot-selector__header";
    heading.className = "naxarly-slot-selector__heading";
    headingCopy.className = "naxarly-slot-selector__heading-copy";
    title.id = "naxarly-slot-selector-title";
    title.className = "naxarly-slot-selector__title";
    title.textContent = "Plan your event";
    subtitle.className = "naxarly-slot-selector__subtitle";
    subtitle.textContent = "Choose where and when your celebration begins.";

    closeButton.className = "naxarly-slot-selector__close";
    closeButton.type = "button";
    closeButton.setAttribute("aria-label", "Close event slot selector");
    closeButton.textContent = "\u00d7";

    form.className = "naxarly-slot-selector__form";
    error.className = "naxarly-slot-selector__error";
    error.setAttribute("role", "alert");

    actions.className = "naxarly-slot-selector__actions";
    submitButton.className = "naxarly-slot-selector__button naxarly-slot-selector__button--primary";
    submitButton.type = "submit";
    submitButton.textContent = "Apply event details";

    headingCopy.appendChild(title);
    headingCopy.appendChild(subtitle);
    heading.appendChild(createIcon("calendar", "naxarly-slot-selector__heading-icon"));
    heading.appendChild(headingCopy);
    header.appendChild(heading);
    header.appendChild(closeButton);
    actions.appendChild(submitButton);
    form.appendChild(locationField.field);
    form.appendChild(dateField.field);
    form.appendChild(timeField.field);
    form.appendChild(error);
    form.appendChild(actions);
    inner.appendChild(header);
    inner.appendChild(form);
    sheet.appendChild(inner);
    root.appendChild(overlay);
    root.appendChild(sheet);
    document.body.appendChild(root);

    elements = {
      root: root,
      form: form,
      dateInput: dateField.input,
      timeInput: timeField.input,
      locationInput: locationField.input,
      locationList: locationField.list,
      error: error,
      closeButton: closeButton,
      submitButton: submitButton
    };

    overlay.addEventListener("click", close);
    closeButton.addEventListener("click", close);
    form.addEventListener("submit", handleSubmit);
    locationField.input.addEventListener("focus", function () {
      drawLocationOptions(locationField.input.value);
    });
    locationField.input.addEventListener("input", function () {
      drawLocationOptions(locationField.input.value);
    });
    locationField.input.addEventListener("keydown", handleLocationKeydown);
    document.addEventListener("pointerdown", function (event) {
      if (!locationField.field.contains(event.target)) closeLocationList();
    });
    document.addEventListener("keydown", handleKeydown);

    isMounted = true;
  }

  function handleKeydown(event) {
    if (event.key === "Escape" && elements.root && elements.root.classList.contains("is-open")) {
      close();
    }
  }

  function setFormSlot(slot) {
    const normalizedSlot = normalizeSlot(slot);

    elements.dateInput.value = normalizedSlot.date;
    elements.timeInput.value = normalizedSlot.time;
    elements.locationInput.value = normalizedSlot.location;
  }

  function readFormSlot() {
    return normalizeSlot({
      date: elements.dateInput.value,
      time: elements.timeInput.value,
      location: elements.locationInput.value
    });
  }

  function validateSlot(slot) {
    if (!slot.date || !slot.time || !slot.location) {
      return "Please choose a date, time, and location.";
    }
    if (!DISTRICT_COORDINATES[slot.location]) {
      return "Please select a Tamil Nadu district from the list.";
    }

    const selectedStart = new Date(slot.date + "T" + slot.time + ":00+05:30");
    if (Number.isNaN(selectedStart.getTime()) || selectedStart.getTime() <= Date.now()) {
      return "Please select an event start time in the future.";
    }

    return "";
  }

  function setLoading(isLoading) {
    elements.submitButton.disabled = isLoading;
    elements.submitButton.textContent = isLoading ? "Checking..." : "Apply event details";
  }

  function clearTemporaryTimers() {
    if (automaticRecheckTimer) window.clearTimeout(automaticRecheckTimer);
    if (countdownTimer) window.clearInterval(countdownTimer);
    automaticRecheckTimer = null;
    countdownTimer = null;
  }

  function showTemporaryReservation(slot, availability) {
    clearTemporaryTimers();
    elements.error.replaceChildren();
    const box = document.createElement("div");
    const title = document.createElement("strong");
    const message = document.createElement("span");
    const countdown = document.createElement("span");
    const button = document.createElement("button");
    box.className = "naxarly-slot-selector__temporary";
    title.textContent = "Temporarily reserved";
    message.textContent = availability.message || "Another customer is completing checkout.";
    button.type = "button";
    button.className = "naxarly-slot-selector__recheck";
    button.textContent = "Check again";
    button.addEventListener("click", function () { elements.form.requestSubmit(); });
    const retryAt = availability.retryAt ? new Date(availability.retryAt) : new Date(Date.now() + 10 * 60_000);
    function drawCountdown() {
      const remaining = Math.max(0, retryAt.getTime() - Date.now());
      const minutes = Math.floor(remaining / 60_000);
      const seconds = Math.floor((remaining % 60_000) / 1000);
      countdown.textContent = "We’ll check again automatically · " + String(minutes).padStart(2, "0") + ":" + String(seconds).padStart(2, "0");
    }
    drawCountdown();
    countdownTimer = window.setInterval(drawCountdown, 1000);
    automaticRecheckTimer = window.setTimeout(function () { elements.form.requestSubmit(); }, 25_000);
    box.append(title, message, countdown, button);
    appendAlternatives(box, availability);
    elements.error.appendChild(box);
  }

  function appendAlternatives(container, availability) {
    const alternatives = (availability.alternativeSlots || []).filter(function (item) { return item.available; });
    if (!alternatives.length) return;
    const holder = document.createElement("div");
    holder.className = "naxarly-slot-selector__alternatives";
    alternatives.forEach(function (item) {
      const date = new Date(item.startsAt);
      const parts = new Intl.DateTimeFormat("en-IN", { timeZone: "Asia/Kolkata", hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).formatToParts(date);
      const hour = parts.find(function (part) { return part.type === "hour"; })?.value || "00";
      const minute = parts.find(function (part) { return part.type === "minute"; })?.value || "00";
      const choice = document.createElement("button");
      choice.type = "button";
      choice.className = "naxarly-slot-selector__alternative";
      choice.textContent = date.toLocaleTimeString("en-IN", { timeZone: "Asia/Kolkata", hour: "numeric", minute: "2-digit" }) + " · Available";
      choice.addEventListener("click", function () { elements.timeInput.value = hour + ":" + minute; elements.form.requestSubmit(); });
      holder.appendChild(choice);
    });
    container.appendChild(holder);
  }

  function notifyListeners(availability) {
    const payload = clone(availability);

    listeners.forEach(function (callback) {
      callback(payload);
    });
  }

  async function handleSubmit(event) {
    event.preventDefault();

    const availabilityApi = getAvailabilityApi();
    const slot = readFormSlot();
    const error = validateSlot(slot);

    clearTemporaryTimers();
    elements.error.textContent = error;

    if (error) {
      return;
    }

    if (!availabilityApi || typeof availabilityApi.check !== "function") {
      elements.error.textContent = "Availability is not ready yet.";
      return;
    }

    setLoading(true);
    setEventAvailability(slot, STATUS_CHECKING);

    try {
      latestAvailability = await Promise.resolve(
        availabilityApi.check(
          slot,
          latestAvailabilityData || getDefaultAvailabilityData()
        )
      );
      setEventAvailability(slot, latestAvailability.status);
      notifyListeners(latestAvailability);
      if (latestAvailability.status === "temporarily_reserved") {
        showTemporaryReservation(slot, latestAvailability);
        return;
      }
      if (latestAvailability.status !== "available") {
        elements.error.textContent =
          latestAvailability.message ||
          "This package is unavailable for the selected event slot.";
        appendAlternatives(elements.error, latestAvailability);
        return;
      }
      close();
    } catch (error) {
      elements.error.textContent = "Availability could not be checked.";
      setEventAvailability(slot, STATUS_UNKNOWN);
    } finally {
      setLoading(false);
    }
  }

  function close() {
    if (!isMounted) {
      return;
    }

    clearTemporaryTimers();
    closeLocationList();
    elements.root.classList.remove("is-open");
    elements.root.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("naxarly-slot-selector-lock");
    if (lastTrigger && typeof lastTrigger.focus === "function") {
      lastTrigger.focus();
    }
  }

  window.Naxarly = window.Naxarly || {};

  window.Naxarly.SlotSelector = {
    /**
     * Open the reusable event slot selector bottom sheet.
     * @param {Object} [options] Optional configuration.
     * @param {Object} [options.availabilityData] Availability data to pass into the availability engine.
     * @returns {Object} The current public API.
     */
    open: function (options) {
      const settings = options || {};

      mount();

      latestAvailabilityData = settings.availabilityData || latestAvailabilityData || getDefaultAvailabilityData();
      elements.error.textContent = "";
      setLoading(false);
      setFormSlot(settings.slot || getSavedSlot());
      elements.root.classList.add("is-open");
      elements.root.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("naxarly-slot-selector-lock");
      const activeTrigger = document.activeElement && document.activeElement.closest
        ? document.activeElement.closest("[data-naxarly-slot-trigger]")
        : null;
      const trigger = activeTrigger || Array.from(document.querySelectorAll("[data-naxarly-slot-trigger]")).find(function (candidate) {
        return candidate.getClientRects().length > 0;
      });
      lastTrigger = trigger || document.activeElement;
      if (trigger) {
        const bounds = trigger.getBoundingClientRect();
        elements.root.style.setProperty("--naxarly-slot-top", Math.max(76, bounds.bottom + 12) + "px");
      }
      elements.locationInput.focus();

      return window.Naxarly.SlotSelector;
    },

    /**
     * Close the event slot selector bottom sheet.
     * @returns {Object} The current public API.
     */
    close: function () {
      close();

      return window.Naxarly.SlotSelector;
    },

    /**
     * Get the currently selected event slot.
     * @returns {Object} A deep clone of the selected slot.
     */
    getSlot: function () {
      if (isMounted && elements.root.classList.contains("is-open")) {
        return clone(readFormSlot());
      }

      return clone(getSavedSlot());
    },

    /**
     * Get the latest availability result.
     * @returns {Object|null} A deep clone of the latest availability result, or null before a check.
     */
    getAvailability: function () {
      return latestAvailability ? clone(latestAvailability) : null;
    },

    /**
     * Subscribe to availability changes.
     * @param {Function} callback Function called with the latest availability result.
     * @returns {Function} Unsubscribe function.
     */
    subscribe: function (callback) {
      if (typeof callback !== "function") {
        return function () {};
      }

      listeners.push(callback);

      return function () {
        listeners = listeners.filter(function (listener) {
          return listener !== callback;
        });
      };
    }
  };
})();
